import Afloop from "afloop"

const ONE_SECOND = 1000 // in milliseconds

export default new class Loop {
    constructor() {
        this.EXPECTED_FRAMES_PER_SECOND = 60
        this.MAXIMUM_MILLISECONDS_PER_FRAME = 1000

        this.delta = {}
        this.stats = {}
        this.time = {
            "s": 0,
            "ms": 0,
            "f": 0,
        }
        window.looper = this
        this.framecount = 0
        this.timer = 1000
        this.lastTime = window.performance.now()

    }
    start(func) {
        return new Afloop((ms) => {
            ms = Math.min(ms, this.MAXIMUM_MILLISECONDS_PER_FRAME)

            this.framecount += 1
            this.currentTime = window.performance.now()
            if(this.currentTime - this.lastTime >= ONE_SECOND) {
                this.stats.fps = Math.round((this.framecount * ONE_SECOND) / (this.currentTime - this.lastTime))
                this.stats.memory = window.performance.memory?.usedJSHeapSize / Math.pow(1024, 2)

                this.lastTime = this.currentTime
                this.framecount = 0
            }

            // Calculate the delta in
            // different units of time.
            this.delta = {
                "ms": ms, // in milliseconds
                "s": ms / 1000, // in seconds
                "f": ms / (1000 / this.EXPECTED_FRAMES_PER_SECOND), // in frames
            }

            this.time.ms += this.delta.ms
            this.time.s += this.delta.s
            this.time.f += this.delta.f

            func(this.delta)
        })
    }
}
